( function( $ ) {
	'use strict';

	const $sliders = $( '.product-slider .swiper' );

	if ( !$sliders.length ) {
		return;
	}

	( function() {

		// Track instances per element
		const sliderMap = new Map();

		// const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
		const mqMobile = window.matchMedia( '(max-width: 748px)' );
		const shouldStack = ( el ) =>
			$( el ).closest( '.product-slider' ).is( '.stack-on-mobile' ) && mqMobile.matches;

		// ---------- Helpers: debounce + (destroy|create|recreate) ----------
		const debounce = ( fn, ms = 150 ) => {
			let t;
			return ( ...args ) => {
				clearTimeout( t );
				t = setTimeout( () => fn( ...args ), ms );
			};
		};

		function destroyOne( el ) {
			const inst = sliderMap.get( el );
			if ( inst && !inst.destroyed ) {
				inst.destroy( true, true );
			}
			sliderMap.delete( el );
		}

		function initialIndexFor( el ) {
			const inst = sliderMap.get( el );
			if ( !inst || inst.destroyed ) return 0;
			// If you ever enable loop, prefer realIndex; else activeIndex is fine
			return inst.params?.loop
				   ? inst.realIndex
				   : inst.activeIndex;
		}

		function createOne( el, initialSlide = 0 ) {
			const $slider = $( el );
			const countSlides = $slider.find( '.card' ).length;

			if ( countSlides <= 1 ){
				return;
			}

			// --- stack vertically on mobile ONLY when .product-slider has .stack-on-mobile
			if ( shouldStack( el ) ) {
				// ensure any previous swiper is gone
				destroyOne( el );
				return null; // do not create a Swiper instance
			}

			let isConstrained = false;
			let $container = $slider.closest( '.is-slider-container' );
			if ( !$container.length ) {
				$container = $slider.closest( '.wp-block-columns' );
				// are we inside a column inside of a tab?
				if ( !$container.length || !$container.parent().is( '.wp-block-colibri-tabs__panel' ) ) {
					$container = [];
				}
			}
			isConstrained = $container.length > 0;

			// adjust breakpoints when used in a .is-target-container wrapper
			const colWidth = isConstrained
							 ? ( ( 1400 - 34 - 32 ) / 3 )
							 : 0; // ~445px

			const slidesPerView = $slider.closest( '.product-slider' ).data( 'column-count' );
			const sliderAlignment = $slider.closest( '.product-slider' ).data( 'slider-alignment' );

			// inject navigation buttons if absent
			if ( !$slider.find( '.swiper-button-next' ).length ) {
				$slider.find( '.swiper-wrapper' ).after( '<div class="swiper-button-next"></div><div class="swiper-button-prev"></div>' );
			}

			let breakpoints = null;

			switch ( Math.min( slidesPerView, countSlides ) ) {
				case 2: {
					breakpoints = {
						[ 375 + colWidth ]: { slidesPerView: 1.2, spaceBetween: 16 },
						[ 730 + colWidth ]: { slidesPerView: Math.min( 2.2, countSlides ), spaceBetween: 24 },
						[ 1200 + colWidth ]: { slidesPerView: Math.min( 3.2, slidesPerView ), spaceBetween: 32 },
					};
					break;
				}
				case 3: {
					breakpoints = isConstrained
						? {
							[ 1024 ]: { slidesPerView: Math.min( 2.2, countSlides ), spaceBetween: 24 },
							[ 1350 ]: { slidesPerView: Math.min( 3.2, countSlides ), spaceBetween: 32 },
						}
								  : {
							[ 375 + colWidth ]: { slidesPerView: 1.2, spaceBetween: 16 },
							[ 730 + colWidth ]: { slidesPerView: Math.min( 2.2, countSlides ), spaceBetween: 24 },
							[ 980 + colWidth ]: { slidesPerView: Math.min( 3.2, countSlides ), spaceBetween: 32 },
						};
					break;
				}
				case 4: {
					breakpoints = {
						[ 375 + colWidth ]: { slidesPerView: 1.2, spaceBetween: 16 },
						[ 730 + colWidth ]: { slidesPerView: Math.min( 2.2, countSlides ), spaceBetween: 24 },
						[ 980 + colWidth ]: { slidesPerView: Math.min( 3.2, countSlides ), spaceBetween: 32 },
						[ 1168 + colWidth ]: { slidesPerView: Math.min( 4.2, countSlides ), spaceBetween: 32 },
					};
					break;
				}
				default: {
					breakpoints = {
						[ 375 + colWidth ]: { slidesPerView: 1.2 },
					};
				}
			}

			function toggleFades( s ) {
				const elNode = s.el;
				// show/hide edge-specific states only if there is overflow
				elNode.classList.toggle( 'is-start', !s.isLocked && s.isBeginning );
				elNode.classList.toggle( 'is-end', !s.isLocked && s.isEnd );
			}

			const args = {
				slidesPerView: 1.2,
				spaceBetween: 16,
				centeredSlides: false,
				centeredSlidesBounds: true,
				centerInsufficientSlides: 'left' !== sliderAlignment,
				loop: false,
				watchOverflow: true,
				freeMode: false,
				slidesPerGroup: 1,
				longSwipes: true,
				longSwipesRatio: 0.2,
				longSwipesMs: 120,
				resistanceRatio: 0.65,
				keyboard: { enabled: true },
				breakpoints,
				grabCursor: true,           // fixed typo
				resistance: false,
				allowTouchMove: true,
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev'
				},
				watchSlidesProgress: true,
				initialSlide,

				on: {
					breakpoint() {
						this.updateSlidesClasses();
					},
					slideChange: ( s ) => toggleFades( s ),
					afterInit: ( s ) => toggleFades( s ),
					reachBeginning: ( s ) => toggleFades( s ),
					reachEnd: ( s ) => toggleFades( s ),
					fromEdge: ( s ) => toggleFades( s ),
					resize: ( s ) => toggleFades( s ),
					lock: ( s ) => toggleFades( s ),
					unlock: ( s ) => toggleFades( s ),
				}
			};

			const instance = new Swiper( el, args );
			sliderMap.set( el, instance );
			return instance;
		}

		function initSliders() {
			$sliders.each( function( index, el ) {
				const $slider = $( el ).addClass( 'swiper-' + index );
				if ( !sliderMap.has( el ) ) {
					createOne( el, 0 );
				}
			} );


		}

		function destroyAll() {
			Array.from( sliderMap.keys() ).forEach( destroyOne );
		}

		function recreateSliders() {
			// Capture current indices
			const indices = new Map();
			$sliders.each( function( _, el ) {
				indices.set( el, initialIndexFor( el ) );
			} );

			// Destroy
			destroyAll();

			// Recreate with preserved positions
			$sliders.each( function( _, el ) {
				const idx = indices.get(el) || 0;
				createOne(el, idx); // createOne() will skip/init based on shouldStack()
			} );

			// Give layout a tick (fonts/images) then update + equalize heights
			requestAnimationFrame( () => {
				Array.from( sliderMap.values() ).forEach( s => s.update() );
				equalizeSlidesHeight();
			} );
		}

		const setSlidersStructuredData = () => {
			const seoPromotedTab = document.querySelector( '[data-seo-promoted]' );

			let seoPromotedSlider = null;

			if ( seoPromotedTab ) {
				const seoPromotedPanelId = seoPromotedTab.getAttribute('aria-controls');

				if ( seoPromotedPanelId ) {
					const seoPromotedPanel = document.getElementById( seoPromotedPanelId );

					if ( seoPromotedPanel ) {
						seoPromotedSlider = seoPromotedPanel.querySelector( '.product-slider .swiper' );
					}
				}
			}

			if ( ! seoPromotedSlider ) {
				seoPromotedSlider = document.querySelector( '.product-slider .swiper' );
			}

			if ( ! seoPromotedSlider ) {
				return;
			}

			const cards = seoPromotedSlider.querySelectorAll( '.swiper-slide' );
			const cardsLength = cards.length;
			let structuredDataItems = '';

			cards.forEach( function( cardEl, cardIndex ) {
				// Product Code.
				const productCode = cardEl.id.replace( 'product-', '' );

				// Product Title.
				const cardTitleEl = cardEl.querySelector( '.card-title' );
				const cardTitle = cardTitleEl ? cardTitleEl.textContent.replace(/"/g, '\\"') : '';

				// Product Description.
				const packageDescClasses = ['.package-items-text', '.package-items', '.product-description'];
				let cardDescEl = null;
				for (const packageDescClass of packageDescClasses) {
					cardDescEl = cardEl.querySelector( packageDescClass );
					if ( cardDescEl ) {
						break;
					}
				}
				const cardDesc = cardDescEl ? cardDescEl.innerHTML.replace(/"/g, '\\"') : '';

				// Product Link.
				const cardLinkEl = cardEl.querySelector( '.details-page-link' );
				const cardLink = cardLinkEl ? cardLinkEl.getAttribute('href') : '';

				// Product Price
				let cardPrice = cardEl.querySelector( '.discounted-price .price-value' );
				if ( ! cardPrice ) {
					cardPrice = cardEl.querySelector( '.regular-price .price-value' );
				}

				let cardPriceValue = '';

				if ( cardPrice ) {
					cardPriceValue = cardPrice.textContent;
				}

				// Offers Category
				let offersCategory = 'Paid';
				if ( cardPriceValue != '' && cardPriceValue == 0 ) {
					offersCategory = 'Free';
				}

				// Course Workload.

				let courseWorkload = +Object.values( window.colibri.index.products ).find( p => p.first_variant.product_code = productCode ).first_variant.primary_hours[0];

				if ( courseWorkload ) {
					courseWorkload = `PT${courseWorkload}H`;
				}

				// Structured Data Items

				structuredDataItems += `{
						"@type": "ListItem",
						"position": ${cardIndex + 1},
						"item": {
							"@type": "Course",
							"url":"${cardLink}",
							"name": "${cardTitle}",
							"description": "${cardDesc}",
							"provider": {
								"@type": "Organization",
								"name": "${window.colibri.analytics[0].brand}",
								"sameAs": "${window.location.origin}"
							},
							"offers": {
								"@type": "Offer",
								"category": "${offersCategory}",
								"price": "${cardPriceValue}",
								"priceCurrency": "USD"
							},
							"hasCourseInstance": [
								{
									"@type": "CourseInstance",
									"courseMode": "Blended",
									"courseWorkload": "${courseWorkload}"
								}
							]
						}
					}`;

				if ( cardIndex < ( cardsLength - 1 ) ) {
					structuredDataItems += ',';
				}
			});

			const structuredDataText = `{
				"@context": "https://schema.org",
				"@type": "ItemList",
				"itemListElement": [
					${structuredDataItems}
				]
			}`;

			const script = document.createElement( 'script' );
			script.setAttribute( 'type', 'application/ld+json' );
			script.textContent = structuredDataText;
			document.head.appendChild( script );
		}

		/**
		 * Making sure all buttons are aligned despite different height of title/pricing components
		 * TODO: Affirm may possibly load prices after this function. Run it after affirm prices are fully loaded if that's the case.
		 */
		const equalizeSlidesHeight = () => {
			const targetElements = [ '.card-title', '.pricing-container', '.package-items-text-intro' ];

			const getPreciseHeight = ( el ) => {
				// Reset before measuring
				el.style.minHeight = '';
				// Use fractional height, then floor to avoid rounding up by 1–2px
				const rect = el.getBoundingClientRect();
				return Math.floor( rect.height );
			};

			const getMaxHeight = ( elements ) => {
				let maxHeight = 0;
				elements.forEach( ( el ) => {
					const h = getPreciseHeight( el );
					if ( h > maxHeight ) {
						maxHeight = h;
					}
				} );
				return maxHeight;
			};

			const setMinHeight = ( elements, height ) => {
				elements.forEach( ( el ) => {
					el.style.minHeight = `${height}px`;
				} );
			};

			const equalizeHeightsForClass = ( selector ) => {
				const elements = document.querySelectorAll( `.swiper-slide ${selector}` );
				if ( !elements.length ) {
					return;
				}
				let maxHeight = getMaxHeight( elements );

				// Clamped titles can show a stray pixel; bias down by 1px
				if ( selector === '.card-title' ) {
					maxHeight = Math.max( 0, maxHeight - 1 );
				}

				setMinHeight( elements, maxHeight );
			};

			targetElements.forEach( ( selector ) => {
				equalizeHeightsForClass( selector );
			} );
		};

		// Re-invoke equalizeSlidesHeight() when .has-affirm is added
		const observePriceClassChanges = () => {
			const priceElements = document.querySelectorAll('.swiper-slide .price');

			priceElements.forEach((priceElement) => {
				const observer = new MutationObserver(() => {
					if (priceElement.classList.contains('has-affirm')) {
						equalizeSlidesHeight();
					}
				});

				observer.observe(priceElement, { attributes: true, attributeFilter: ['class'] });
			});
		};

		/**
		 *
		 */
		const listenForFilterRequests = () => {
			const e = 'COLIBRI::PACKAGE_LICENSE_LEVEL_TRANSITION_FILTER';
			if ( typeof window?.colibri?.eventsQueue?.[ e ] !== 'undefined' ) {
				//looks like we have missed one request already
				filterSlides( e, window.colibri.eventsQueue[ e ] );
			}
			$( window ).bind( e, filterSlides );
		}

		const filterSlides = ( e, data ) => {
			const codes = data?.showPackages.split( ',' );

			if ( !codes.length || codes[ 0 ] === 'all' ) {
				//un-filter all cards
				const $cardsToShow = $sliders.find( '.card--product-slide:not(:visible)' );
				$cardsToShow.each( ( idx, card ) => {
					$( card ).show();
				} );
				if ( $cardsToShow.length ) {
					updateSliders();
				}
				return;
			}

			var countFlipped = 0;
			$sliders.find( '.card--product-slide' ).each( ( idx, card ) => {
				const $card = $( card );
				const productCode = $card.attr( 'id' ).replace( 'product-', '' ).replace( 'course-', '' );
				if ( codes.indexOf( productCode ) === - 1 ) {
					if ( $card.is( ':visible' ) ) {
						$card.hide();
						countFlipped ++;
					}
				} else {
					if ( !$card.is( ':visible' ) ) {
						$card.show();
						countFlipped ++;
					}
				}
			} );

			if ( countFlipped ) {
				updateSliders();
			}
		} // filterSlides()

		const updateSliders = () => {
			Array.from( sliderMap.values() ).forEach( swiper => swiper.update() );
		};

		// ---------- Boot ----------
		const startAll = () => {
			initSliders();
			listenForFilterRequests();
			setSlidersStructuredData();
			equalizeSlidesHeight();
			observePriceClassChanges();
		};

		if ( typeof window.swiper === 'undefined' ) {
			// load swiper slider scripts and styles
			var scriptUrl = 'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.js';
			var styleUrl = 'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.css';
			$( 'head' ).append( '<link rel="stylesheet" type="text/css" href="' + styleUrl + '">' );
			$( document ).ready( function() {
				$.getScript( scriptUrl, function() {
					startAll();
				} );
			} );
		} else {
			startAll();
		}

		// Recreate on resize/orientation change (debounced)
		const onResize = debounce( () => {
			recreateSliders();
		}, 150 );

		window.addEventListener( 'resize', onResize );
		window.addEventListener( 'orientationchange', onResize );

		// also react to media query flips (some browsers may not fire resize in all cases)
		if ( mqMobile.addEventListener ) mqMobile.addEventListener( 'change', onResize );
		else if ( mqMobile.addListener ) mqMobile.addListener( onResize );

	} )();
} )( jQuery );
